import { connect } from "react-redux";
import Component from "../components/AppHeader";
import { setUIVisibilityState, sendNotification, goToSlide } from "../actions";
var mapStateToProps = function(state, _ownProps) {
    var slide = state.nodes.find(function(n) {
        return n.id === state.currentSlide;
    });
    var _chapters = state.nodes.filter(function(n) {
        return n.target_type === "Filter";
    });
    var closestsChapter = slide && _chapters.find(function(n) {
        return n.c.indexOf(slide.id) > -1;
    });
    var chapters = [];
    var rec = function(c) {
        chapters.push(c);
        var cc = _chapters.find(function(n) {
            return n.c.indexOf(c.id) > -1;
        });
        if (cc) {
            rec(cc);
        }
    };
    if (closestsChapter) {
        rec(closestsChapter);
    }
    return {
        currentSlide: state.currentSlide,
        logoUrl: state.cbook ? state.cbook.logo : "",
        logoLink: state.cbook ? state.cbook.logo_link_node_id : "",
        cbookName: state.cbook && state.cbook.name || "",
        slideTitle: slide ? slide.name : "",
        uiVisibilityState: state.uiVisibilityState,
        chapters: chapters.reverse(),
        navDisabled: Boolean(state.exam && state.exam.state === "running")
    };
};
var mapDispatchToProps = function(dispatch, _ownProps) {
    return {
        setUIVisibilityState: function(state) {
            dispatch(setUIVisibilityState({
                state: state
            }));
        },
        notify: function(id) {
            var messageProps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            dispatch(sendNotification({
                key: "ui.".concat(id),
                label: "",
                message: id,
                messageProps: messageProps
            }));
        },
        goTo: function(id, origin) {
            dispatch(goToSlide({
                id: id,
                origin: origin
            }));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Component);
